import React from 'react';
import { MessageSquare } from 'lucide-react';
import './EmptyState.css';

const EmptyState = () => {
  return (
    <div className="empty-state">
      <MessageSquare className="empty-icon" />
      <p>Select a vendor to view messages</p>
    </div>
  );
};

export default EmptyState;